import { Component, OnInit } from '@angular/core';
import {modelSet} from '../webData';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {
  models: any;
  constructor() { }

  ngOnInit() {
    this.models = modelSet;
  }


}



// WEBPACK FOOTER //
// /Users/samirjha/Project/nushing/src/app/product/product.component.ts